import { SummaryStatsCard } from '@exam-center/components';
import { useGetExamEventExamineeCountSummaryQuery } from '@exam-center/graphql';
import { useParams } from '@exam-center/router';
import { Flex, PaperSection } from '@shared/components';

import { ExamineeList } from '../examinee-list';
import { ImportExamineesButton } from '../import-examinees-button';

export default function ExamineesSummary() {
  const { examEventId } = useParams('/:examCenterCode/exam-events/:examEventId/examinees');

  const {
    data: examEventExamineeCountSummaryData,
    loading: isExamEventExamineeCountSummaryLoading,
  } = useGetExamEventExamineeCountSummaryQuery({
    variables: {
      getExamEventExamineeCountSummaryInput: {
        examEventId: examEventId,
      },
    },
  });

  const {
    total = 0,
    prepareForExam = 0,
    registered = 0,
    inProgress = 0,
    processing = 0,
    pendingResults = 0,
    completed = 0,
    absent = 0,
    eKyc = 0,
    canceled = 0,
  } = examEventExamineeCountSummaryData?.ecGetExamEventExamineeCountSummary ?? {};

  const attended =
    prepareForExam + registered + inProgress + processing + pendingResults + completed;

  return (
    <PaperSection title='รายชื่อผู้มีสิทธิ์สอบ' endAdornment={<ImportExamineesButton />}>
      <Flex
        sx={(theme) => ({
          flexDirection: 'column',
          gap: theme.spacing(6),
          p: theme.spacing(6),
        })}
      >
        <Flex sx={{ gap: (theme) => theme.spacing(4) }}>
          <SummaryStatsCard
            title='จำนวนผู้ที่ทำ e-KYC แล้ว'
            displayValue={`${eKyc}/${total} คน`}
            loading={isExamEventExamineeCountSummaryLoading}
          />
          <SummaryStatsCard
            title='จำนวนผู้ที่เข้าสอบทั้งหมด'
            displayValue={`${attended} คน`}
            loading={isExamEventExamineeCountSummaryLoading}
          />
          <SummaryStatsCard
            title='จำนวนผู้ที่ขาดสอบทั้งหมด'
            displayValue={`${absent} คน`}
            loading={isExamEventExamineeCountSummaryLoading}
          />
          <SummaryStatsCard
            title='จำนวนผู้ถูกยกเลิก'
            displayValue={`${canceled} คน`}
            loading={isExamEventExamineeCountSummaryLoading}
          />
        </Flex>
        <ExamineeList examEventId={examEventId} />
      </Flex>
    </PaperSection>
  );
}
